<template>
  <el-select
    :placeholder="placeholder"
    v-model="sValue"
    @input="$emit('input', $event)"
    :multiple="multiple"
    :style="{ width: '100%' }"
    :loading="pageData.loading"
    clearable
    :filterable="true"
    @clear="clear"
    @change="change"
    :disabled="disabled"
    @blur="selectBlur"
    v-emoji>
    <slot name="options" :list="pageData.list" :click="handleClick"></slot>
    <el-pagination
      hide-on-single-page
      small=""
      :page-sizes="[pageData.pageSize]"
      :page-size="pageData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.totalItem"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-count="pageData.totalPage"
      :current-page="pageData.currentPage" />
  </el-select>
</template>
<script>
import onInit from "@/utils/oninit1";
export default {
  name: "pageSelect",
  mixins: [onInit],
  props: {
    value: {
      type: [String, Number, Array],
      required: false,
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    param: {
      type: Object,
    },
    module: {
      type: String,
      default: "",
      required: false,
    },
    moduleFun: {
      type: String,
      default: "",
      required: false,
    },
    multiple: {
      type: [String, Boolean, Number],
      default: false,
    },
    filterable: {
      type: [String, Boolean, Number],
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formSearch: this.param,
      sValue: this.value,
      moduleName: this.module,
      moduleFunName: this.moduleFun,
      sName: this.name,
      isChange: false,
    };
  },
  watch: {
    param(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
        return;
      }
      this.formSearch = newValue;
      this.fetchTableList();
    },
    value(newValue) {
      console.log(newValue);
      this.sValue = newValue;
    },
  },
  methods: {
    handleClick(value, source, key, item) {
      // 防止选择跟上次同一个选项时也触发change
      if (this.isChange) {
        this.isChange = false;
        // this.$emit("change", item);
      }

      source[key] = value;
      this.obj = source;
      this.key = key;
      this.item = item;
      this.$emit("chuancan");
      this.$emit("chuancan1", this.pageData.list);
    },

    beforeFetchTableList(value) {
      console.log("beforeFetchTableList");
      this.formSearch = { ...this.formSearch, keyword: value };
      this.$emit("searchUEmits", this.formSearch);
      //this.fetchTableList()
    },
    clear(item) {
      console.log(this.obj, this.key);
      this.$emit("searchUEmits", this.formSearch);
      this.$emit("clearUEmits");
      // this.obj[this.key] = null
    },
    change(value) {
      if (value === "" || value == null || value == undefined) {
      } else {
        this.isChange = true;
      }
      this.$emit("updateHUi", this.formSearch);
      this.$emit("chuancan2", this.pageData.list);
    },
    // 失去焦点
    selectBlur() {
      // 防止选择时失去焦点，导致选中失败
      setTimeout(() => {
        this.beforeFetchTableList("");
      }, 100);
    },
  },
};
</script>
<style></style>
